const languageCodeEnum = new Map();

languageCodeEnum.set(1, 'HI');
languageCodeEnum.set(2, 'EN');
languageCodeEnum.set(3, 'MR');

export default languageCodeEnum;
